import React from "react";
import { FlexContainer } from "../../../constants/assets/containers";
import styled from "styled-components";

const DeliveryPartnerBlankState = () => {
  return (
    <DPBlankState data-testid="partner-blank-state">
      <img src="/images/DP/DpBlankState.svg" alt="dp" />
    </DPBlankState>
  );
};

const DPBlankState = styled(FlexContainer)`
  height: calc(100vh - 200px);
  justify-content: center;

  img {
    width: 180px;
    height: auto;
  }
`;

export default React.memo(DeliveryPartnerBlankState);
